import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useFetch } from "../../lib/api";
import { SectionLabel, Chip } from "../shared";

export default function UsaHubSection() {
  const { data: regulators } = useFetch("/regulators");
  return (
    <section className="bg-[#F3EEE4] border-y border-[#E7E0D2]">
      <div className="max-w-[1320px] mx-auto px-5 lg:px-8 py-20 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <SectionLabel color="#E8590C">New · USA Regulatory Hub</SectionLabel>
          <h2 className="font-display font-bold text-[34px] lg:text-[46px] leading-[1.08] tracking-tight">
            America's most complete <span className="text-[#E8590C]">compliance deep-dive</span> for risk teams
          </h2>
          <p className="mt-5 text-[16px] leading-relaxed text-[#1A1914]/65">
            Deep-dive compliance guides for <strong className="text-[#1A1914]">SEC, Federal Banking Agencies, CISA, FinCEN, NIST and NYDFS</strong> — control catalogues, applicability matrices, compliance calendars, penalty frameworks, and free templates for US risk & local-government professionals.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <Chip>6 regulators</Chip>
            <Chip>CIRCIA 72-hour clock</Chip>
            <Chip>12 templates · 6 free</Chip>
            <Chip className="!text-[#0E9355] !border-[#12B76A]/30 !bg-[#12B76A]/5">NYDFS 2025 updated</Chip>
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/usa" data-testid="usa-hub-cta" className="inline-flex items-center gap-2 px-6 py-3.5 text-[15px] font-semibold text-white bg-[#E8590C] hover:bg-[#C2410C] rounded-xl rp-btn shadow-md">
              Explore USA Hub <ArrowRight size={16} />
            </Link>
            <Link to="/usa#breach-playbook" className="inline-flex items-center gap-2 px-6 py-3.5 text-[15px] font-semibold text-[#1A1914] bg-white border border-[#E7E0D2] hover:border-[#1A1914]/40 rounded-xl rp-btn">
              Try the breach-clock playbook <ArrowRight size={15} />
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3" data-testid="regulator-cards">
          {(regulators || []).map((r) => (
            <Link key={r.slug} to={`/usa/${r.slug}`} className="rp-card bg-white border border-[#E7E0D2] rounded-xl px-5 py-5 group">
              <p className="font-mono-label text-[10px] text-[#1A1914]/40">{r.abbr}</p>
              <p className="mt-2 text-[14.5px] font-semibold leading-snug text-[#1A1914] group-hover:text-[#E8590C] transition-colors">{r.card}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
